
import { defineComponent, PropType } from "vue"
import { Service } from "@/js/types/service"
import { User } from "@/js/types/user"

export default defineComponent({
    name: "DashboardSidebar",
    props: {
        userServices: {
            type: Array as PropType<Service[]>,
            required: true,
        },
    },
    emits: ["open-service"],
    data: () => ({
        isCollapsed: false,
        isMobileOpened: false,
    }),
    computed: {
        user(): User {
            return this.$page.props.auth.user
        },
        openedService(): Service {
            return {
                id: -1,
                name: "test",
                title: "Test",
                url: "test",
                iconUri: null,
                forceExternalOpen: false,
            }
        },
    },
    methods: {
        openService(service: Service, inNewTab: boolean = false) {
            this.isMobileOpened = false
            document?.scrollingElement?.scrollTo(0, 0)

            if (!service.forceExternalOpen) this.$emit("open-service", service, inNewTab)
        },
    },
})
